module.exports = __webpack_public_path__ + "assets/img/ac4c28ab0c4502a91db571ebfdf3a24b.svg";